<template>
  <div class="footer">
    <b-container class="footer-container">
    <div class="row mt-4 footer-up-row">
      <div class="col-lg-3 col-md-6">
         <img class="invesnow-logo mt-n4" src="@/assets/img/footer/invesnow-logo.svg" alt="invesnow-logo">
        <p class="mt-4 mb-2">Berizin dan Diawasi</p>
         <img class="ojk-logo" src="@/assets/img/footer/ojk-logo.webp" alt="invesnow-logo">
      </div>
      <div class="col-lg-2 col-md-6 company">
          <h3 class="mb-4">COMPANY</h3>
          <h4 class="my-2">
              <b-link class="footer-link" href="https://invesnow.id/tentang-kami" >
                  Tentang Kami
              </b-link>
          </h4>               
          <h4 class="my-2">
            <b-link class="footer-link" href="https://invesnow.id/karir" >
                  Karir
              </b-link>
          </h4>               
          <h4 class="my-2">
            <b-link class="footer-link" href="https://invesnow.id/artikel" >
                  Blog
              </b-link>
          </h4>               
          <h4 class="my-2">
          <b-link class="footer-link" href="https://invesnow.id/hubungi-kami" >
                  Kontak
              </b-link>
          </h4>              
      </div>
      <div class="col-lg-2 col-md-6 support">
          <h3 class="mb-4">SUPPORT</h3>
          <!-- <h4 class="my-2">
              <b-link class="footer-link" to="/panduan">
                  Panduan
              </b-link>
          </h4>                -->
          <h4 class="my-2">
              <b-link class="footer-link" href="https://invesnow.id/faq" >
                  FAQ
              </b-link>
          </h4>               
          <h4 class="my-2">
              <b-link class="footer-link" href="https://invesnow.id/syarat-dan-ketentuan" >
                  Syarat & Ketentuan
              </b-link>
          </h4>   
      </div>
      <div class="col-lg-5 col-md-6 newsletter">
          <h1>Newsletter</h1>
          <p>Segarkan wawasan investasi Anda setiap harinya dengan berita-berita financial dari newsletter kami.</p>
          <b-row class="p-3"> 
          <div>
          <b-form class="email-form" inline @submit.prevent="handleSubmit">
              <label class="sr-only" for="email">Masukkan Email Anda</label>
              <b-form-input
              id="email"
              v-model="email"
              required
              class="mb-4 mr-sm-2 mb-sm-0"
              placeholder="Masukkan Email Anda"
              ></b-form-input>

              <b-button @click="handleSubmit()" :disabled="loading"
              class="btn-subscribe py-2">
              <div v-if="loading">
                <div class="spinner-border spinner-border-sm">
                </div>
                Loading
              </div>
              <div v-else>
                Subscribe
              </div>
              </b-button>
          </b-form>
          </div>
          </b-row>
      </div>
    </div>
    <div>
        <b-jumbotron>
            <hr>
        </b-jumbotron>
    </div> 
    <div class="row footer-down-row">
      <div class="col-lg-10 col-md-6">
        <p>&#64; {{ new Date().getFullYear() }} PT Invesnow Principal Optima</p>
      </div>

      <div class="col-lg-2 col-md-6">
        <div class="row footer-down-row">
                <div class="mx-2">
                    <b-link href="https://www.linkedin.com/company/invesnow/mycompany/" ><img src="@/assets/img/icons/social-media/linkedin-icon.webp" alt="linkedin-icon"></b-link>
                </div>
                <div class="mx-2">
                    <b-link href="https://www.instagram.com/invesnow.id/" ><img src="@/assets/img/icons/social-media/instagram-icon.webp" alt="instagram-icon"></b-link>
                </div>
                <div class="mx-2">
                    <b-link href="https://twitter.com/InvesnowID" ><img src="@/assets/img/icons/social-media/twitter-icon.webp" alt="twitter-icon"></b-link>
                </div>
                <div class="mx-2">
                    <b-link href="https://web.facebook.com/invesnow.id" ><img src="@/assets/img/icons/social-media/facebook-icon.webp" alt="facebook-icon"></b-link>
                </div>          
        </div>
      </div>
    </div>

        <div class="modal-subscribe">
          <b-modal
            id="modal-success-subscribe"
            v-model="show"
            size="md"
            class="modal-success-subscribe"
            centered
            hide-footer
          >
            <div class="d-block text-center">
              <img src="@/assets/img/subscribe/success-subscribe.svg" alt="success-subscribe" />
              <h1 class="p-4 my-2 text-dark">
                Hore! <br />
                Sukses Berlangganan 
              </h1>
              <p>Segarkan wawasan investasi<br>dengan berita-berita dari kami.</p>
            </div>
          </b-modal>
          
          <b-modal
            id="modal-failed-subscribe"
            v-model="subscribedShow"
            size="md"
            class="modal-failed-subscribe"
            centered
            hide-footer
          >
            <div class="d-block text-center">
              <img src="@/assets/img/subscribe/subscribed.svg" alt="subscribed" />
              <h1 class="p-4 my-2 text-dark">
                Anda sudah berlangganan
              </h1>
              <p>Kami mengirimkan berita seputar investasi ke email Anda.</p>
            </div>
          </b-modal>
        </div>

    </b-container>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "Footer",
  data() {
    return {

        show: false,
        subscribedShow: false,
        email: "",
        loading: false,
        processing: false,
    };
  },
  methods: {
    handleSubmit() {
      if (!this.processing) {
      this.processing = true;

      let params = {

        'email' : this.email,

        };

      let axiosConfig = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios.post("https://investamart-ka9.mailtrgt.com/form/611f705ddcb8710006b22905", params, axiosConfig)
        .then((res) => {
          console.log("RESPONSE RECEIVED: ", res);
          this.show = true;

          this.loading=!false
          setTimeout(()=> {
            this.loading=!true
          }, 2000);
          this.email = '';
              
        })
        .catch((err) => {
          console.log("AXIOS ERROR: ", err);
          this.subscribedShow = true;
          this.email = '';
          this.processing = false;
        });
    }
    }
  }    
}
</script>

<style lang="scss" scoped>
.footer {
background: #1F0439;
}

.footer-container{
padding-top: 40px;
padding-bottom: 20px;    
}

  h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: white;
  }

  h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  color: #6B7280;
  }

  h4 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  }


  p {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #9CA3AF;
  }
  

  .modal-subscribe{
    z-index: 99999;
    h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    }
    p {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    }
  }

.invesnow-logo {
width: 140px;
}

.form-control {
width: 295px;    
}

.form-control:focus {
outline: none !important;
border:1px solid !important;
box-shadow: none !important;
}

.jumbotron {
    padding: 0;
    background-color: white;
    opacity: 0.3;
}

.footer-link {
font-style: normal;
font-weight: normal;
font-size: 16px;
color: #D1D5DB;
text-decoration: none;       
}

@media only screen and (max-width: 768px) {
.footer-up-row {
text-align: center;
}
.company{
margin-top: 20px;
}
.support {
margin-top: 20px;
}
.newsletter {
margin-top: 20px;
}
.btn-subscribe {
margin: auto;
}
.email-form {
display: flex;
align-items: center;
justify-content: center;
}
.footer-down-row {
text-align: center;
display: flex;
align-items: center;
justify-content: center;
}
}
</style>